var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessageInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6302 12.3417C20.9311 12.1634 21.1183 11.8416 21.1183 11.4914C21.1183 11.1102 20.8966 10.7626 20.5478 10.5973L4.43255 2.95568C4.06032 2.77917 3.61639 2.84433 3.31259 3.12007C3.00879 3.39581 2.90669 3.82625 3.05499 4.206L5.84812 11.3581C5.84217 11.4017 5.8391 11.4462 5.8391 11.4915C5.8391 11.5366 5.84217 11.5811 5.84811 11.6247L3.05499 18.7767C2.90668 19.1565 3.00879 19.5869 3.31259 19.8627C3.61639 20.1384 4.06032 20.2036 4.43255 20.0271L20.5319 12.393C20.5657 12.3776 20.5985 12.3605 20.6302 12.3417ZM15.6955 10.4991L5.84824 5.82971L7.6718 10.4991H15.6955ZM15.6951 12.4838H7.67174L5.84824 17.153L15.6951 12.4838Z",
    fill: "#3F4860"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageInactive);
export default __webpack_public_path__ + "static/media/send-message-inactive.bbd9a631.svg";
export { ForwardRef as ReactComponent };